export default {
  bookExperiencePanel: 'B\u1ea3ng \u0111\u1eb7t tr\u1ea3i nghi\u1ec7m',
  calendarIcon: 'Bi\u1ec3u t\u01b0\u1ee3ng l\u1ecbch',
  coverImageForResource:
    '\u1ea2nh b\u00eca cho tr\u1ea3i nghi\u1ec7m {{title}}',
  filterBy: 'L\u1ecdc theo {{filter}}',
  filterByDateRange: 'L\u1ecdc theo kho\u1ea3ng ng\u00e0y',
  gallery: 'Th\u01b0 vi\u1ec7n \u1ea3nh',
  goBack: 'Quay l\u1ea1i trang tr\u01b0\u1edbc',
  hostUserIcon: 'bi\u1ec3u t\u01b0\u1ee3ng ng\u01b0\u1eddi t\u1ed5 ch\u1ee9c',
  imageOf: 'H\u00ecnh \u1ea3nh c\u1ee7a {{title}}',
  interactiveMapAltText:
    'B\u1ea3n \u0111\u1ed3 t\u01b0\u01a1ng t\u00e1c v\u1edbi {{title}} c\u00f3 th\u1ec3 ch\u1ecdn',
  mediaSlides: 'Trang chi\u1ebfu ph\u01b0\u01a1ng ti\u1ec7n',
  muteVideo: 'T\u1eaft ti\u1ebfng video',
  nextPhoto: '\u1ea2nh ti\u1ebfp theo',
  noVideoPlayback:
    'Kh\u00f4ng c\u00f3 kh\u1ea3 n\u0103ng ph\u00e1t l\u1ea1i video',
  pauseVideo: 'T\u1ea1m d\u1eebng video',
  photoOf: '\u1ea3nh c\u1ee7a {{name}}',
  playVideo: 'Ph\u00e1t video',
  previousPhoto: '\u1ea2nh tr\u01b0\u1edbc',
  moreFiltersAndExperiences:
    'Th\u00eam b\u1ed9 l\u1ecdc v\u00e0 tr\u1ea3i nghi\u1ec7m',
  reserveSelectedSlot: '\u0110\u1eb7t ch\u1ed7 \u0111\u00e3 ch\u1ecdn',
  reviewRating: '\u0110i\u1ec3m \u0111\u00e1nh gi\u00e1 {{rating}} tr\u00ean 5',
  overallReviewRating:
    '\u0110i\u1ec3m \u0111\u00e1nh gi\u00e1 t\u1ed5ng th\u1ec3 {{rating}} tr\u00ean 5',
  selectCountryCodeForPhoneNumber:
    'Ch\u1ecdn m\u00e3 qu\u1ed1c gia cho s\u1ed1 \u0111i\u1ec7n tho\u1ea1i',
  selectDate: 'Ch\u1ecdn ng\u00e0y',
  selectParticipants: 'Ch\u1ecdn ng\u01b0\u1eddi tham gia',
  selectSessionTime: 'Ch\u1ecdn gi\u1edd phi\u00ean',
  unmuteVideo: 'B\u1eadt ti\u1ebfng video',
  viewShoppingCart: 'Xem gi\u1ecf h\u00e0ng',
  itemsInCart: '{{count}} m\u1eb7t h\u00e0ng trong gi\u1ecf h\u00e0ng',
  zoomIn: 'Ph\u00f3ng to',
  zoomOut: 'Thu nh\u1ecf',
  selectData: `Ch\u1ecdn {{data}}`,
  reserveName: `\u0110\u1eb7t {{name}}`,
  deleteReservation: 'X\u00f3a \u0111\u1eb7t ch\u1ed7 {{experienceTitle}}',
  editParticipantsFor:
    'Ch\u1ec9nh s\u1eeda ng\u01b0\u1eddi tham gia cho {{experienceTitle}}',
  enterPromoCode: 'Nh\u1eadp m\u00e3 khuy\u1ebfn m\u00e3i',
  applyPromoCode: '\u00c1p d\u1ee5ng m\u00e3 khuy\u1ebfn m\u00e3i',
  increaseAddOnAmount: 'T\u0103ng {{addOn}} \u0111\u00e3 ch\u1ecdn',
  decreaseAddOnAmount: 'Gi\u1ea3m {{addOn}} \u0111\u00e3 ch\u1ecdn',
  addOnModal: 'C\u1eeda s\u1ed5 {{addOn}}',
  moreInformationAboutAddOn: 'Th\u00eam th\u00f4ng tin v\u1ec1 {{addOn}}',
  decreasePriceTierTickets: 'Gi\u1ea3m v\u00e9 {{priceTier}}',
  increasePriceTierTickets: 'T\u0103ng v\u00e9 {{priceTier}}',
  downloadFilename: 'T\u1ea3i xu\u1ed1ng {{filename}}',
  viewFullDetailsDescription:
    'Xem m\u00f4 t\u1ea3 chi ti\u1ebft \u0111\u1ea7y \u0111\u1ee7',
  viewFullDescription: 'Xem m\u00f4 t\u1ea3 \u0111\u1ea7y \u0111\u1ee7',
  closeModal: '\u0110\u00f3ng c\u1eeda s\u1ed5',
  hyattBanner:
    'Banner \u0110\u1eb7c Quy\u1ec1n Th\u00e0nh Vi\u00ean World Of Hyatt',
  hyattBannerDesc:
    'Banner qu\u1ea3ng c\u00e1o cho bi\u1ebft c\u00e1c quy\u1ec1n l\u1ee3i v\u00e0 \u01b0u \u0111\u00e3i \u0111\u1eb7c bi\u1ec7t d\u00e0nh cho th\u00e0nh vi\u00ean ch\u01b0\u01a1ng tr\u00ecnh kh\u00e1ch h\u00e0ng th\u00e2n thi\u1ebft World of Hyatt',
  previousSlide: 'Trang chi\u1ebfu tr\u01b0\u1edbc',
  nextSlide: 'Trang chi\u1ebfu ti\u1ebfp theo',
  paginationBulletMessage: 'Chuy\u1ec3n \u0111\u1ebfn trang chi\u1ebfu',
  exitFullscreen:
    'Tho\u00e1t ch\u1ebf \u0111\u1ed9 to\u00e0n m\u00e0n h\u00ecnh',
  enterFullscreen:
    'V\u00e0o ch\u1ebf \u0111\u1ed9 to\u00e0n m\u00e0n h\u00ecnh',
  videoSlide: 'Trang chi\u1ebfu video',
  imageSlide: 'Trang chi\u1ebfu h\u00ecnh \u1ea3nh',
  of: 'c\u1ee7a',
  noDescription: 'Kh\u00f4ng c\u00f3 m\u00f4 t\u1ea3',
  mediaGallery: 'Carousel - Th\u01b0 vi\u1ec7n ph\u01b0\u01a1ng ti\u1ec7n',
  dateSelector: 'Bộ chọn ngày',
  nextWeek: 'Tuần sau',
  previousWeek: 'Tuần trước',
  scheduleAgenda: 'Lịch trình',
  scheduleNav: 'Điều hướng lịch trình',
  scheduleViewSelector: 'Bộ chọn chế độ xem lịch trình',
  selectedDateAriaLabel: '{{date}}, đã chọn',
  tapToBookExperience: 'Đặt {{title}}',
  bookExperienceAriaLabel: 'Đặt {{title}}',
  joinWaitlistAriaLabel: 'Tham gia danh sách chờ cho {{title}}',
};
